import { ModalController } from '@ionic/angular';

import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Component, ElementRef, OnInit, ViewChild, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl,Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-form-add-text-for-model-inferencing',
  templateUrl: './form-add-text-for-model-inferencing.component.html',
  styleUrls: ['./form-add-text-for-model-inferencing.component.scss'],
})

export class FormAddTextForModelInferencingComponent implements OnInit {

  @Input() initiator:string = "";
  addTextForm!: FormGroup;

  formData = {
    text: ''
  };

  constructor(private modalCtrl: ModalController,private fb: FormBuilder,private apiService:ApiService,private router:Router,private globalService:GlobalService,private alertController: AlertController) {
    this.addTextForm = this.fb.group({
      textArray: this.fb.array([])
    });

    this.addFormEntry(); // Add one default entry
  }
  ngOnInit(){
    console.log(this.initiator)
    this.resetForm();
  }

  ionViewWillEnter() {
    this.resetForm();
  }

  get textArray() {
    return this.addTextForm.get('textArray') as FormArray;
  }

  addFormEntry() {
    const formEntry = this.fb.group({
      message: ['',[Validators.required]],
      
    });

    this.textArray.push(formEntry);
    
  }

  removeFormEntry(index: number) {
    this.textArray.removeAt(index);
  }

  goToMenu() {
    this.router.navigate(['/menu']);
  }

  closeModal(target:string) {
    if(target=='save'){

      if(this.initiator && this.initiator == 'modelinferencing'){
        
        let data = {
          textArray:this.textArray.value,
        }
        this.modalCtrl.dismiss(data);    
      }
      else{
        this.modalCtrl.dismiss();    
      }
    }else{
      this.modalCtrl.dismiss();    
    }
  }

  saveData() {
    console.log(this.formData);
    this.modalCtrl.dismiss(this.formData);
  }


  async onSubmit() {
    try {
      this.globalService.storeDataLoading();
      if (this.addTextForm.valid) {
        const formArray = this.textArray.controls;
        let apiCalls = 0;
  
        formArray.forEach((control: AbstractControl, index: number) => {
          const formGroup = control as FormGroup;
          const formValue = formGroup.value;

          const message = formValue.message
          const model_name = localStorage.getItem('selectedModel');
          const lang = localStorage.getItem('selectedModelLanguageForTTS');
          const formData = { message,lang, model_name };
          this.apiService.modelInference(formData).subscribe(response => {
            console.log('Model Inferenced Successfully:', response);
            apiCalls++;
            // this.closeModal('save')
            if (apiCalls === formArray.length) {
              setTimeout(() => {
                this.closeModal('save');
                this.globalService.dismissLoading();
              }, 1000); 
            }
          }, error => {
            console.error('Model Inferenced error:', error);
          });
  
         
        });

        

        // setTimeout(()=>{
        //   this.closeModal('save')
        // },0)
  
      }
      
      

      
    } catch (error) {
      console.log('Form is invalid');

      
    }
  }


  resetForm() {
    // Clear all entries in the FormArray
    while (this.textArray.length !== 0) {
      this.textArray.removeAt(0);
    }
  
    // Add a fresh default entry
    this.addFormEntry();
  
  }

  onToggleChange(event: any, index: number, field: string) {
    this.textArray.at(index).patchValue({ [field]: event.detail.checked });
  }

//   async confirmLogout() {
//     const alert = await this.alertController.create({
//           header: 'Confirm Logout',
//           message: 'Are you sure you want to log out?',
//           buttons: [
//               {
//                   text: 'Cancel',
//                   role: 'cancel',
//                   handler: () => {
//                       // Do nothing when the user cancels
//                   }
//               },
//               {
//                   text: 'Logout',
//                   handler: async () => {
//                       // this.stopRecordingOnly();
//                       await this.LogoutFunction();
//                   }
//               }
//           ]
//       });

//       await alert.present();
//     // }else{
//     //   await this.LogoutFunction();
//     // }
// }

// async LogoutFunction(){

//     try{
//         this.globalService.logoutLoading();
//         const res:any = await this.apiService.logoutUser().toPromise();
            

//         localStorage.removeItem('authenticationKey');
//         localStorage.removeItem('accent');
//         localStorage.removeItem('age');
//         localStorage.removeItem('gender');
//         localStorage.removeItem('userId');
//         localStorage.removeItem('userName');
//         localStorage.removeItem('language');

//         localStorage.removeItem('searchedText');
//         localStorage.removeItem('selectedModel');
//         localStorage.removeItem('selectedModelLanguageForTTS');
//         localStorage.removeItem('selectedOptionUser');
//         localStorage.removeItem('textCategory');
//         localStorage.removeItem('totalCountData');
//         localStorage.removeItem('usersList');

//         this.globalService.dismissLoading();
      
//         this.router.navigate(['login']);



      
    
//     }catch(error){
//       console.log("Error:", error);
//       // this.globalService.dismissLoading();
//       this.router.navigate(['login']);

//     }  
//   };

}

